/* tslint:disable */
import * as React from 'react';
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link';

const About = () => {
    document.title = "About";
    return (
        <div style={{marginTop: "20px", marginLeft: "20px"}}>
            <Typography variant={"body2"}>修士（工学）取得後、化学系研究職で３年強働いた後にWebエンジニアに転職。</Typography>
            <Typography variant={"body2"}>元々は有機化学、材料科学あたりの研究をしていました。</Typography>
            <Typography variant={"body2"}>フロントエンドの練習がてら適当なもの作ってます。仕事ではAPIも書いてます。</Typography>
            <Typography variant={"body2"} style={{marginTop: "20px"}}>公開しているツールは簡単な動作確認は行っておりますが、不具合があるかもしれません。ご了承ください。</Typography>
            <Typography variant={"body2"}>モル計算機の処理は全てクライアント側で動いているので、外部との通信は発生しません（一旦読み込んでしまえばオフラインになっても動作します）。</Typography>
            <Link href="https://twitter.com/i_ll">Twitter</Link>
            <Link href="https://i-ll.hatenablog.com/" style={{marginLeft: "20px"}}>Hatena</Link>
        </div>
    );
};

export default About


// WEBPACK FOOTER //
// ./src/components/About.tsx